"use client";

import Link from "next/link";
import { useRouter, useSearchParams } from "next/navigation";

export function PaymentFailureContent() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const ref = searchParams.get("ref");

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-20 text-center">
      {/* Red exclamation icon */}
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full border-2 border-red-500">
        <svg
          aria-hidden="true"
          className="h-14 w-14 -translate-y-0.5 text-red-500"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>Payment unsuccessful</title>
          <path d="M12 9v4M12 17h.01" />
        </svg>
      </div>

      <h1 className="heading-1 mb-3 font-bold">Payment Unsuccessful</h1>

      <p className="mb-2 max-w-md text-muted-foreground">
        Something went wrong and we couldn&apos;t process your payment.
      </p>
      <p className="mb-6 max-w-md text-muted-foreground">
        If this persists, please{" "}
        <Link
          className="underline decoration-1 underline-offset-4 hover:opacity-80"
          href="/contact"
        >
          contact us
        </Link>
        .
      </p>

      {ref && (
        <p className="mb-8 font-semibold">Transaction Reference: {ref}</p>
      )}

      <button
        className="mb-8 rounded-lg bg-foreground px-6 py-2.5 font-medium text-background text-sm transition-opacity hover:opacity-80"
        onClick={() => router.back()}
        type="button"
      >
        Back
      </button>

      <p className="text-muted-foreground text-sm italic">
        All payments are securely processed by Paystack.
      </p>
    </div>
  );
}
